import CustomSelection from './custom-selection';

export default class Sport extends CustomSelection {
}
